import React from 'react'

const ErrorMessage = ({ errorMessage, alignRight }) => {
    return (
        <p className={`${alignRight && "self-end"} bg-rose-200 w-fit-content px-2 rounded-lg text-left py-1 font-bold text-rose-500 my-4 mb-2 ${alignRight}`}>* {errorMessage}</p>
    )
}

export default ErrorMessage